<template>
  <div class="table-header">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative">
      <div class="w-full w-md-auto md-flex-1">
        <div class="d-md-none">
          <button type="button" class="button-tooltip text-dark font-weight-bold m-0" v-b-tooltip.hover
            title="Recargar" @click="$emit('reload')">
            <i class="ri-loop-right-line"></i>
          </button>
        </div>
      </div>

      <section class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0">
        <div class="d-none d-md-flex">
          <button type="button" class="button-tooltip text-dark font-weight-bold" v-b-tooltip.hover title="Recargar"
            @click="$emit('reload')">
            <i class="ri-loop-right-line"></i>
          </button>
        </div>
        <div class="w-full w-md-auto d-flex">
          <SearchBar placeholder="Buscar distrito..." :oldValue="oldValue" class="flex-1" @search="doSearch" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { Alert, SearchBar } from 'wize-admin'

// Cabecera estándar de tabla para los cuatro niveles del módulo (departamentos,
// provincias, distritos y resultados). Se comparte porque las cuatro páginas
// llevan exactamente los mismos controles.
//
// El buscador es global por el DEF-ADM-016 §6.4: busca por nombre de distrito
// en todo el catálogo, sin importar el nivel en el que estés. Por eso emite en
// 'search' (Enter) y no filtra la tabla de la página actual.
export default {
  name: 'UbigeoTableHeader',
  components: { SearchBar },
  props: {
    // Precarga el campo al volver a la vista de resultados.
    oldValue: { type: String, default: '' }
  },
  methods: {
    doSearch(keyword) {
      const q = (keyword || '').trim()
      if (q.length < 2) {
        Alert.info('Escribe al menos 2 caracteres para buscar')
        return
      }
      this.$router.push({ name: 'ubigeo-search', query: { q } })
    }
  }
}
</script>
